if (!customElements.get('onepod-catalog-controls')) {
  class OnePodCatalogControls extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('onepod-catalog-filters');
      this.filtersColumn = document.querySelector('.catalog-results__filters');
      this.sortBy = this.querySelector('.onepod-catalog-controls__sort');
      this.layoutSwitcher = this.querySelector('.onepod-catalog-controls__layout');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.onepod-filter-toggle');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', OnePodCatalogControls.handleSortByChange);
      }

      if (this.layoutSwitcher) {
        this.productsGrid = document.querySelector('.catalog-results');

        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));
        this.handleBreakpointChangeListener = this.handleBreakpointChange.bind(this);
        window.addEventListener('onepod:layout-change', this.handleBreakpointChangeListener);

        this.applySelectedLayout();
      }
    }

    disconnectedCallback() {
      if (this.layoutSwitcher) {
        window.removeEventListener('onepod:layout-change', this.handleBreakpointChangeListener);
      }
    }

    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      this.filtersComponent.open();
    }

    handleLayoutChange(evt) {
      const layoutColumns = this.currentColumns;

      if (window.onePodLayoutSupports('navigation')) {
        this.productsGrid.dataset.columnsLg = evt.target.value;
        layoutColumns.lg = evt.target.value;
      } else if (window.onePodLayoutSupports('split')) {
        this.productsGrid.dataset.columnsMd = evt.target.value;
        layoutColumns.md = evt.target.value;
      } else if (window.onePodLayoutSupports('roomy')) {
        this.productsGrid.dataset.columnsSm = evt.target.value;
        layoutColumns.sm = evt.target.value;
      } else if (!window.onePodLayoutSupports('roomy')) {
        this.productsGrid.dataset.columnsMobile = evt.target.value;
        layoutColumns.mobile = evt.target.value;
      }

      try {
        const persistedColumns = JSON.stringify(layoutColumns);
        sessionStorage.setItem('op-products-layout', persistedColumns);
      } catch (e) {
        //
      }
    }

    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'onepod-catalog-controls';
      window.location.href = urlObj.toString();
    }

    applySelectedLayout() {
      const persistedColumns = sessionStorage.getItem('op-products-layout');
      if (!persistedColumns) return;

      try {
        const layoutColumns = JSON.parse(persistedColumns);

        this.productsGrid.dataset.columnsLg = layoutColumns.lg;
        this.productsGrid.dataset.columnsMd = layoutColumns.md;
        this.productsGrid.dataset.columnsSm = layoutColumns.sm;
        this.productsGrid.dataset.columnsMobile = layoutColumns.mobile;

        this.updateSelectedLayoutOption();
      } catch (e) {
        //
      }
    }

    handleBreakpointChange() {
      this.updateSelectedLayoutOption();
    }

    updateSelectedLayoutOption() {
      const layoutColumns = this.currentColumns;
      let selectedValue;

      if (window.onePodLayoutSupports('navigation')) {
        selectedValue = layoutColumns.lg;
      } else if (window.onePodLayoutSupports('split')) {
        selectedValue = layoutColumns.md;
      } else if (window.onePodLayoutSupports('roomy')) {
        selectedValue = layoutColumns.sm;
      } else if (!window.onePodLayoutSupports('roomy')) {
        selectedValue = layoutColumns.mobile;
      }

      const options = Array.from(this.layoutSwitcher.querySelectorAll('input[name="products-layout"]'));
      options.forEach((option) => {
        option.checked = (option.value === selectedValue);
      });
    }

    get currentColumns() {
      return {
        mobile: this.productsGrid.dataset.columnsMobile,
        sm: this.productsGrid.dataset.columnsSm,
        md: this.productsGrid.dataset.columnsMd,
        lg: this.productsGrid.dataset.columnsLg
      };
    }
  }

  customElements.define('onepod-catalog-controls', OnePodCatalogControls);
}
